import {IM} from "@cvte/message-service-sdk";
import EventEmitter from "eventemitter2";
import { MyIM } from "./_im";
interface IMTaskManagerParams {
  onConnected?: () => void;
  onIsConnectingChange?: (newValue: boolean) => void;
  onIsValidChange?: (newValue: boolean) => void;
}

export class SeewoIM {
  private eventEmitter = new EventEmitter();
  private imInstance: typeof IM | null = null;
  private isConnecting = false;
  private isValid = true;
  private isConnectingChangeHandler: ((isConnecting: boolean) => void) | undefined;
  private isValidChangeHandler: ((isValid: boolean) => void) | undefined;

  public get isConnected() {
    return this.imInstance?.getIsConnected();
  }

  private onConnected?: () => void;

  public constructor(params?: IMTaskManagerParams) {
    if (!params) return;
    const { onIsConnectingChange, onIsValidChange, onConnected } = params;
    if (onIsConnectingChange) {
      this.isConnectingChangeHandler = onIsConnectingChange;
    }
    if (onIsValidChange) {
      this.isValidChangeHandler = onIsValidChange;
    }
    if (onConnected) {
      this.onConnected = onConnected;
    }
  }

  private setIsConnecting = (newValue: boolean) => {
    if (this.isConnecting === newValue) return;
    this.isConnecting = newValue;
    this.isConnectingChangeHandler && this.isConnectingChangeHandler(newValue);
  };

  public getIsConnecting = () => this.isConnecting;

  private setIsValid = (newValue: boolean) => {
    // if (this.isValid === newValue) return;
    this.isValid = newValue;
    this.isValidChangeHandler && this.isValidChangeHandler(newValue);
  };

  public getIsValid = () => this.isValid;

  // 连接
  // eslint-disable-next-line arrow-body-style
  public connect = () => {
    this.imInstance = new MyIM({
      connectCb: async (data) => {
        console.log(`connectCb`, data);
        this.onConnected?.();
        this.setIsConnecting(false);
        this.setIsValid(true);
      },
      recvMsgCb: (data) => {
        this.handleIMRecvMsg(data);
      },
      reConnectCb: () => {
        this.setIsConnecting(true);
      },
      disconnectCb: () => {
        this.setIsValid(false);
      },
      onSingleCommandRecvCb: (data) => {
        this.handleIMSingleCommandRecv(data);
      }
    });
  };

  public disconnect() {
    if (this.imInstance) {
      this.imInstance.logout();
      this.imInstance = null;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public subscribe(topic: string, callback: (res: any) => void) {
    this.eventEmitter.on(topic, callback);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public unsubscribe(topic: string, callback: (res: any) => void) {
    this.eventEmitter.off(topic, callback);
  }

  private handleIMRecvMsg(data: unknown) {
    const message = JSON.parse((data as { msg: string }).msg);
    console.log(" ==== im handleMessageRecv ====", message);
    this.eventEmitter.emit(message.topic, message.data);
  }

  private handleIMSingleCommandRecv(data: unknown) {
    console.log(" ==== im handleSingleCommandRecv ====", data);
    const messageObj = JSON.parse((data as { msg: string }).msg);

    const topic = messageObj.messageType;
    this.eventEmitter.emit(topic, messageObj);
  }
}

const im = new SeewoIM();
export default im;